import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './Advantage.css';
import * as flightStyles from './AdvantageFlight.css';
import { IType, IFlightType } from '../../../containers/AdvantagesContainer/type';

export const Advantage = ({
  flightEnabled,
  title,
  description,
  type,
}: {
  flightEnabled: boolean;
  title: string;
  description: string;
  type: IType | IFlightType;
}) => {
  // TODO: удалить одну из версий после флайта
  const currentStyles = flightEnabled ? flightStyles : styles;

  return (
    <div className={currentStyles['advantage']}>
      <div className={clsx(currentStyles['icon'], currentStyles[type])}></div>
      <div className={currentStyles['content']}>
        <div className={currentStyles['title']}>{title}</div>
        <div className={currentStyles['description']}>{description}</div>
      </div>
    </div>
  );
};
